//import axios from "axios";
import settingHTTP from "./settings";

const serviceLogin = {
  async login(data) {
    return await settingHTTP.post("/Identity/authentication", data);
  },

  async loginMicrosoft(data) {
    return await settingHTTP.post("/Identity/login/microsoft", data);
  },
};
export default serviceLogin;
